// Audio file mapping for vocabulary words
// This maps English words to their corresponding audio file URLs
export const vocabularyAudioMap: { [category: string]: { [word: string]: string } } = {
  "colors": {
    "red": "/audio/vocabulary/colors/red.mp3",
    "blue": "/audio/vocabulary/colors/blue.mp3",
    "green": "/audio/vocabulary/colors/green.mp3",
    "yellow": "/audio/vocabulary/colors/yellow.mp3",
    "black": "/audio/vocabulary/colors/black.mp3",
    "white": "/audio/vocabulary/colors/white.mp3"
  },
  "family": {
    "family": "/audio/vocabulary/family/family.mp3",
    "father": "/audio/vocabulary/family/father.mp3",
    "mother": "/audio/vocabulary/family/mother.mp3",
    "brother": "/audio/vocabulary/family/brother.mp3",
    "sister": "/audio/vocabulary/family/sister.mp3",
    "grandfather": "/audio/vocabulary/family/grandfather.mp3",
    "grandmother": "/audio/vocabulary/family/grandmother.mp3",
    "uncle": "/audio/vocabulary/family/uncle.mp3",
    "aunt": "/audio/vocabulary/family/aunt.mp3",
    "uncle_mother": "/audio/vocabulary/family/uncle_mother.mp3",
    "aunt_mother": "/audio/vocabulary/family/aunt_mother.mp3",
    "son": "/audio/vocabulary/family/son.mp3",
    "daughter": "/audio/vocabulary/family/daughter.mp3",
    "spouse": "/audio/vocabulary/family/spouse.mp3",
    "husband": "/audio/vocabulary/family/husband.mp3",
    "wife": "/audio/vocabulary/family/wife.mp3"
  },
  "kitchen": {
    "befarmayid": "/audio/vocabulary/kitchen/befarmayid.mp3",
    "sofreh": "/audio/vocabulary/kitchen/sofreh.mp3",
    "changal fork": "/audio/vocabulary/kitchen/changal_fork.mp3",
    "ghashogh spoon": "/audio/vocabulary/kitchen/ghashogh_spoon.mp3",
    "noon bread": "/audio/vocabulary/kitchen/noon_bread.mp3",
    "ab water": "/audio/vocabulary/kitchen/ab_water.mp3",
    "noosh jan": "/audio/vocabulary/kitchen/noosh_jan.mp3",
    "booy khoshi mideh": "/audio/vocabulary/kitchen/booy_khoshi_mideh.mp3",
    "mehman guest": "/audio/vocabulary/kitchen/mehman_guest.mp3",
    "lezzat bebar": "/audio/vocabulary/kitchen/lezzat_bebar.mp3",
    "بفرمایید، اینجا بنشینید.": "/audio/vocabulary/kitchen/بفرمایید،_اینجا_بنشینید..mp3",
    "مرسی! چه سفره‌ی قشنگی!": "/audio/vocabulary/kitchen/مرسی!_چه_سفره‌ی_قشنگی!.mp3",
    "این چنگاله؟": "/audio/vocabulary/kitchen/این_چنگاله؟.mp3",
    "بله، چنگال. و این یکی قاشقه.": "/audio/vocabulary/kitchen/بله،_چنگال._و_این_یکی_قاشقه..mp3",
    "میشه یکم نون بدید؟": "/audio/vocabulary/kitchen/میشه_یکم_نون_بدید؟.mp3",
    "بفرما. آب هم می‌خوای؟": "/audio/vocabulary/kitchen/بفرما._آب_هم_می‌خوای؟.mp3",
    "نوش جان! امیدوارم خوشت بیاد.": "/audio/vocabulary/kitchen/نوش_جان!_امیدوارم_خوشت_بیاد..mp3",
    "نوش جان! بوی خوشی می‌ده!": "/audio/vocabulary/kitchen/نوش_جان!_بوی_خوشی_می‌ده!.mp3",
    "می‌خواین کمک کنم؟": "/audio/vocabulary/kitchen/می‌خواین_کمک_کنم؟.mp3",
    "نه عزیزم، شما مهمان هستید! فقط بشین و لذت ببر.": "/audio/vocabulary/kitchen/نه_عزیزم،_شما_مهمان_هستید!_فقط_بشین_و_لذت_ببر..mp3",
    "berenj rice": "/audio/vocabulary/kitchen/berenj_rice.mp3",
    "beshor wash": "/audio/vocabulary/kitchen/beshor_wash.mp3",
    "bekhaboon soak": "/audio/vocabulary/kitchen/bekhaboon_soak.mp3",
    "peymaneh cup": "/audio/vocabulary/kitchen/peymaneh_cup.mp3",
    "dam koni steam cloth": "/audio/vocabulary/kitchen/dam_koni_steam_cloth.mp3",
    "dam bekasheh steam": "/audio/vocabulary/kitchen/dam_bekasheh_steam.mp3",
    "tah dig crispy rice": "/audio/vocabulary/kitchen/tah_dig_crispy_rice.mp3",
    "roghan oil": "/audio/vocabulary/kitchen/roghan_oil.mp3",
    "dag kon heat up": "/audio/vocabulary/kitchen/dag_kon_heat_up.mp3",
    "khoshmazeh delicious": "/audio/vocabulary/kitchen/khoshmazeh_delicious.mp3",
    "namak salt": "/audio/vocabulary/kitchen/namak_salt.mp3",
    "ghablemeh pot": "/audio/vocabulary/kitchen/ghablemeh_pot.mp3",
    "اول برنج رو بشور. بعد با نمک بخوابون.": "/audio/vocabulary/kitchen/اول_برنج_رو_بشور._بعد_با_نمک_بخوابون..mp3",
    "باشه مامان‌جون. چند پیمانه آب بریزم؟": "/audio/vocabulary/kitchen/باشه_مامان‌جون._چند_پیمانه_آب_بریزم؟.mp3",
    "دو پیمانه آب واسه یه پیمانه برنجه. یادت نره، دم‌کنی بذار!": "/audio/vocabulary/kitchen/دو_پیمانه_آب_واسه_یه_پیمانه_برنجه._یادت_نره،_دم‌کنی_بذار!.mp3",
    "چشم! برنج ایرانی سخته ولی خوشمزه‌ست!": "/audio/vocabulary/kitchen/چشم!_برنج_ایرانی_سخته_ولی_خوشمزه‌ست!.mp3",
    "حالا دم‌کنی رو بذار رو قابلمه. بذار برنج دم بکشه.": "/audio/vocabulary/kitchen/حالا_دم‌کنی_رو_بذار_رو_قابلمه._بذار_برنج_دم_بکشه..mp3",
    "چند دقیقه باید دم بکشه؟": "/audio/vocabulary/kitchen/چند_دقیقه_باید_دم_بکشه؟.mp3",
    "حدود بیست دقیقه. تا وقتی بوی خوشی بده.": "/audio/vocabulary/kitchen/حدود_بیست_دقیقه._تا_وقتی_بوی_خوشی_بده..mp3",
    "برای ته‌دیگ، روغن رو داغ کن. بعد برنج رو بذار.": "/audio/vocabulary/kitchen/برای_ته‌دیگ،_روغن_رو_داغ_کن._بعد_برنج_رو_بذار..mp3",
    "ته‌دیگ چیه مامان؟": "/audio/vocabulary/kitchen/ته‌دیگ_چیه_مامان؟.mp3",
    "ته‌دیگ یعنی ته دیگ. برنج طلایی و ترد که همه عاشقش هستن!": "/audio/vocabulary/kitchen/ته‌دیگ_یعنی_ته_دیگ._برنج_طلایی_و_ترد_که_همه_عاشقش_هستن!.mp3",
    "مامان! برنجم آماده شد! بوی خوشی می‌ده!": "/audio/vocabulary/kitchen/مامان!_برنجم_آماده_شد!_بوی_خوشی_می‌ده!.mp3",
    "آفرین پسرم! حالا می‌تونی برنج ایرانی درست کنی!": "/audio/vocabulary/kitchen/آفرین_پسرم!_حالا_می‌تونی_برنج_ایرانی_درست_کنی!.mp3",
    "مرسی مامان! بدون کمک تو نمی‌تونستم!": "/audio/vocabulary/kitchen/مرسی_مامان!_بدون_کمک_تو_نمی‌تونستم!.mp3",
    "ghormeh sabzi": "/audio/vocabulary/kitchen/ghormeh_sabzi.mp3",
    "sabzi herbs": "/audio/vocabulary/kitchen/sabzi_herbs.mp3",
    "jafari parsley": "/audio/vocabulary/kitchen/jafari_parsley.mp3",
    "geshniz cilantro": "/audio/vocabulary/kitchen/geshniz_cilantro.mp3",
    "tareh leek": "/audio/vocabulary/kitchen/tareh_leek.mp3",
    "shevid dill": "/audio/vocabulary/kitchen/shevid_dill.mp3",
    "khard kon chop": "/audio/vocabulary/kitchen/khard_kon_chop.mp3",
    "sorkh kon fry": "/audio/vocabulary/kitchen/sorkh_kon_fry.mp3",
    "loobia beans": "/audio/vocabulary/kitchen/loobia_beans.mp3",
    "gosht meat": "/audio/vocabulary/kitchen/gosht_meat.mp3",
    "limoo amani dried lime": "/audio/vocabulary/kitchen/limoo_amani_dried_lime.mp3",
    "khoresht stew": "/audio/vocabulary/kitchen/khoresht_stew.mp3",
    "اول سبزی‌ها رو خرد کن. بعد پیاز رو سرخ کن.": "/audio/vocabulary/kitchen/اول_سبزی‌ها_رو_خرد_کن._بعد_پیاز_رو_سرخ_کن..mp3",
    "کدوم سبزی‌ها رو بذارم؟": "/audio/vocabulary/kitchen/کدوم_سبزی‌ها_رو_بذارم؟.mp3",
    "جعفری، گشنیز، تره، و شوید. اینا سبزی‌های اصلی قورمه سبزی هستن.": "/audio/vocabulary/kitchen/جعفری،_گشنیز،_تره،_و_شوید._اینا_سبزی‌های_اصلی_قورمه_سبزی_هستن..mp3",
    "سبزی‌ها رو با روغن سرخ کن تا بوی خوشی بدن.": "/audio/vocabulary/kitchen/سبزی‌ها_رو_با_روغن_سرخ_کن_تا_بوی_خوشی_بدن..mp3",
    "چند دقیقه باید سرخ کنم؟": "/audio/vocabulary/kitchen/چند_دقیقه_باید_سرخ_کنم؟.mp3",
    "حدود ده دقیقه. تا وقتی سبز تیره بشن.": "/audio/vocabulary/kitchen/حدود_ده_دقیقه._تا_وقتی_سبز_تیره_بشن..mp3",
    "حالا گوشت و لوبیا رو اضافه کن. با آب بپز.": "/audio/vocabulary/kitchen/حالا_گوشت_و_لوبیا_رو_اضافه_کن._با_آب_بپز..mp3",
    "چقدر آب بریزم؟": "/audio/vocabulary/kitchen/چقدر_آب_بریزم؟.mp3",
    "دو لیوان آب کافیه. بذار آروم بپزه.": "/audio/vocabulary/kitchen/دو_لیوان_آب_کافیه._بذار_آروم_بپزه..mp3",
    "در آخر، لیمو عمانی رو اضافه کن. این طعم خاص میده.": "/audio/vocabulary/kitchen/در_آخر،_لیمو_عمانی_رو_اضافه_کن._این_طعم_خاص_میده..mp3",
    "لیمو عمانی چیه؟": "/audio/vocabulary/kitchen/لیمو_عمانی_چیه؟.mp3",
    "لیموی خشک شده که طعم ترش و خوشی میده. بدونش قورمه سبزی کامل نیست!": "/audio/vocabulary/kitchen/لیموی_خشک_شده_که_طعم_ترش_و_خوشی_میده._بدونش_قورمه_سبزی_کامل_نیست!.mp3",
    "مامان! قورمه سبزیم آماده شد! بوی خوشی می‌ده!": "/audio/vocabulary/kitchen/مامان!_قورمه_سبزیم_آماده_شد!_بوی_خوشی_می‌ده!.mp3",
    "آفرین! حالا می‌تونی قورمه سبزی درست کنی!": "/audio/vocabulary/kitchen/آفرین!_حالا_می‌تونی_قورمه_سبزی_درست_کنی!.mp3",
    "مرسی مامان! این خورش خیلی خوشمزه‌ست!": "/audio/vocabulary/kitchen/مرسی_مامان!_این_خورش_خیلی_خوشمزه‌ست!.mp3",
    "nan barbari": "/audio/vocabulary/kitchen/nan_barbari.mp3",
    "khamir dough": "/audio/vocabulary/kitchen/khamir_dough.mp3",
    "varz bedeh knead": "/audio/vocabulary/kitchen/varz_bedeh_knead.mp3",
    "ard flour": "/audio/vocabulary/kitchen/ard_flour.mp3",
    "mokhammar yeast": "/audio/vocabulary/kitchen/mokhammar_yeast.mp3",
    "makhloot kon mix": "/audio/vocabulary/kitchen/makhloot_kon_mix.mp3",
    "pahn kon spread": "/audio/vocabulary/kitchen/pahn_kon_spread.mp3",
    "for oven": "/audio/vocabulary/kitchen/for_oven.mp3",
    "bepaz bake": "/audio/vocabulary/kitchen/bepaz_bake.mp3",
    "khotoot lines": "/audio/vocabulary/kitchen/khotoot_lines.mp3",
    "esterahat koneh rest": "/audio/vocabulary/kitchen/esterahat_koneh_rest.mp3",
    "اول آرد و آب و مخمر رو مخلوط کن. بعد خمیر رو ورز بده.": "/audio/vocabulary/kitchen/اول_آرد_و_آب_و_مخمر_رو_مخلوط_کن._بعد_خمیر_رو_ورز_بده..mp3",
    "چقدر باید ورز بدم مامان؟": "/audio/vocabulary/kitchen/چقدر_باید_ورز_بدم_مامان؟.mp3",
    "حدود ده دقیقه. تا وقتی خمیر نرم و کش‌دار بشه.": "/audio/vocabulary/kitchen/حدود_ده_دقیقه._تا_وقتی_خمیر_نرم_و_کش‌دار_بشه..mp3",
    "حالا خمیر رو بپوشون و بذار یک ساعت استراحت کنه.": "/audio/vocabulary/kitchen/حالا_خمیر_رو_بپوشون_و_بذار_یک_ساعت_استراحت_کنه..mp3",
    "چرا باید استراحت کنه؟": "/audio/vocabulary/kitchen/چرا_باید_استراحت_کنه؟.mp3",
    "مخمر باید کارش رو بکنه. خمیر باید پف کنه و بزرگ بشه.": "/audio/vocabulary/kitchen/مخمر_باید_کارش_رو_بکنه._خمیر_باید_پف_کنه_و_بزرگ_بشه..mp3",
    "حالا خمیر رو پهن کن. با انگشت خطوط بکش.": "/audio/vocabulary/kitchen/حالا_خمیر_رو_پهن_کن._با_انگشت_خطوط_بکش..mp3",
    "چرا خطوط می‌کشم؟": "/audio/vocabulary/kitchen/چرا_خطوط_می‌کشم؟.mp3",
    "این خطوط بربری رو از بقیه نون‌ها متمایز می‌کنه. زیبایی خاصی داره.": "/audio/vocabulary/kitchen/این_خطوط_بربری_رو_از_بقیه_نون‌ها_متمایز_می‌کنه._زیبایی_خاصی_داره..mp3",
    "فر رو داغ کن. دویست درجه سانتیگراد.": "/audio/vocabulary/kitchen/فر_رو_داغ_کن._دویست_درجه_سانتیگراد..mp3",
    "چند دقیقه باید بپزم؟": "/audio/vocabulary/kitchen/چند_دقیقه_باید_بپزم؟.mp3",
    "حدود بیست دقیقه. تا وقتی طلایی و ترد بشه.": "/audio/vocabulary/kitchen/حدود_بیست_دقیقه._تا_وقتی_طلایی_و_ترد_بشه..mp3",
    "مامان! نون بربریم آماده شد! بوی خوشی می‌ده!": "/audio/vocabulary/kitchen/مامان!_نون_بربریم_آماده_شد!_بوی_خوشی_می‌ده!.mp3",
    "آفرین پسرم! حالا می‌تونی نون بربری درست کنی!": "/audio/vocabulary/kitchen/آفرین_پسرم!_حالا_می‌تونی_نون_بربری_درست_کنی!.mp3",
    "مرسی مامان! این نون خیلی خوشمزه‌ست!": "/audio/vocabulary/kitchen/مرسی_مامان!_این_نون_خیلی_خوشمزه‌ست!.mp3",
    "bademjan eggplant": "/audio/vocabulary/kitchen/bademjan_eggplant.mp3",
    "kashk": "/audio/vocabulary/kitchen/kashk.mp3",
    "sir garlic": "/audio/vocabulary/kitchen/sir_garlic.mp3",
    "leh kon mash": "/audio/vocabulary/kitchen/leh_kon_mash.mp3",
    "ezafeh kon add": "/audio/vocabulary/kitchen/ezafeh_kon_add.mp3",
    "felfel pepper": "/audio/vocabulary/kitchen/felfel_pepper.mp3",
    "amadeh ready": "/audio/vocabulary/kitchen/amadeh_ready.mp3",
    "poost begir peel": "/audio/vocabulary/kitchen/poost_begir_peel.mp3",
    "tazyin kon garnish": "/audio/vocabulary/kitchen/tazyin_kon_garnish.mp3",
    "اول بادمجان‌ها را پوست بگیر": "/audio/vocabulary/kitchen/اول_بادمجان‌ها_را_پوست_بگیر.mp3",
    "حالا چکار کنم؟": "/audio/vocabulary/kitchen/حالا_چکار_کنم؟.mp3",
    "بادمجان را سرخ کن": "/audio/vocabulary/kitchen/بادمجان_را_سرخ_کن.mp3",
    "بادمجان را له کنم؟": "/audio/vocabulary/kitchen/بادمجان_را_له_کنم؟.mp3",
    "بله، بعد کشک و سیر را اضافه کن": "/audio/vocabulary/kitchen/بله،_بعد_کشک_و_سیر_را_اضافه_کن.mp3",
    "نمک و فلفل بزن": "/audio/vocabulary/kitchen/نمک_و_فلفل_بزن.mp3",
    "غذا آماده است؟": "/audio/vocabulary/kitchen/غذا_آماده_است؟.mp3",
    "بله، نوش جان!": "/audio/vocabulary/kitchen/بله،_نوش_جان!.mp3",
    "kabab": "/audio/vocabulary/food/kebab.mp3",
    "pic nic": "/audio/vocabulary/kitchen/pic_nic.mp3",
    "gojeh tomato": "/audio/vocabulary/kitchen/gojeh_tomato.mp3",
    "piyaz onion": "/audio/vocabulary/kitchen/piyaz_onion.mp3",
    "zoghal charcoal": "/audio/vocabulary/kitchen/zoghal_charcoal.mp3",
    "kabab kardan grilling": "/audio/vocabulary/kitchen/kabab_kardan_grilling.mp3",
    "charkhandan turning": "/audio/vocabulary/kitchen/charkhandan_turning.mp3",
    "roshan kardan lighting": "/audio/vocabulary/kitchen/roshan_kardan_lighting.mp3",
    "dorchin around": "/audio/vocabulary/kitchen/dorchin_around.mp3",
    "park": "/audio/vocabulary/kitchen/park.mp3",
    "پینگ‌کواک! بیا کمک کن پیک نیک درست کنیم": "/audio/vocabulary/kitchen/پینگ‌کواک!_بیا_کمک_کن_پیک_نیک_درست_کنیم.mp3",
    "چه کار کنم؟": "/audio/vocabulary/kitchen/چه_کار_کنم؟.mp3",
    "اول ذغال روشن کن، بعد کباب بذار": "/audio/vocabulary/kitchen/اول_ذغال_روشن_کن،_بعد_کباب_بذار.mp3",
    "چقدر صبر کنم؟": "/audio/vocabulary/kitchen/چقدر_صبر_کنم؟.mp3",
    "کباب را بچرخون تا هر طرف پخته بشه": "/audio/vocabulary/kitchen/کباب_را_بچرخون_تا_هر_طرف_پخته_بشه.mp3",
    "چقدر زیبا بوی میده!": "/audio/vocabulary/kitchen/چقدر_زیبا_بوی_میده!.mp3",
    "گوجه و پیاز هم کباب کن": "/audio/vocabulary/kitchen/گوجه_و_پیاز_هم_کباب_کن.mp3",
    "گوجه چقدر بذارم روی آتش؟": "/audio/vocabulary/kitchen/گوجه_چقدر_بذارم_روی_آتش؟.mp3",
    "بفرمایید، کباب آماده است": "/audio/vocabulary/kitchen/بفرمایید،_کباب_آماده_است.mp3",
    "ممنون! خیلی خوشمزه است": "/audio/vocabulary/kitchen/ممنون!_خیلی_خوشمزه_است.mp3",
    "آش رشته درست کن": "/audio/vocabulary/kitchen/آش_رشته_درست_کن.mp3",
    "ادویه اضافه کن": "/audio/vocabulary/kitchen/ادویه_اضافه_کن.mp3",
    "سبزی خرد کن": "/audio/vocabulary/kitchen/سبزی_خرد_کن.mp3",
    "آب جوش اضافه کن": "/audio/vocabulary/kitchen/آب_جوش_اضافه_کن.mp3",
    "نمک بزن": "/audio/vocabulary/kitchen/نمک_بزن.mp3",
    "shirini sweets": "/audio/vocabulary/kitchen/shirini_sweets.mp3",
    "zafaran saffron": "/audio/vocabulary/kitchen/zafaran_saffron.mp3",
    "shekar sugar": "/audio/vocabulary/kitchen/shekar_sugar.mp3",
    "golab rosewater": "/audio/vocabulary/kitchen/golab_rosewater.mp3",
    "nowruz": "/audio/vocabulary/kitchen/nowruz.mp3",
    "halva": "/audio/vocabulary/kitchen/halva.mp3",
    "پینگ‌کواک، بیا شیرینی درست کنیم": "/audio/vocabulary/kitchen/پینگ‌کواک،_بیا_شیرینی_درست_کنیم.mp3",
    "چه شیرینی؟": "/audio/vocabulary/kitchen/چه_شیرینی؟.mp3",
    "زعفران خیلی مهمه، رنگ طلایی میده": "/audio/vocabulary/kitchen/زعفران_خیلی_مهمه،_رنگ_طلایی_میده.mp3",
    "وای، چقدر زیبا!": "/audio/vocabulary/kitchen/وای،_چقدر_زیبا!.mp3",
    "ba ejazeh excuse me": "/audio/vocabulary/kitchen/ba_ejazeh_excuse_me.mp3",
    "dast shoma dard nakoneh": "/audio/vocabulary/kitchen/dast_shoma_dard_nakoneh.mp3",
    "nah mersi no thanks": "/audio/vocabulary/kitchen/nah_mersi_no_thanks.mp3",
    "بفرمایید، سر سفره": "/audio/vocabulary/kitchen/بفرمایید،_سر_سفره.mp3",
    "ممنون، با اجازه": "/audio/vocabulary/kitchen/ممنون،_با_اجازه.mp3",
    "نوش جان!": "/audio/vocabulary/kitchen/نوش_جان!.mp3",
    "بیشتر بخور، دست من درد نکنه": "/audio/vocabulary/kitchen/بیشتر_بخور،_دست_من_درد_نکنه.mp3",
    "نه مرسی، خیلی خوشمزه بود": "/audio/vocabulary/kitchen/نه_مرسی،_خیلی_خوشمزه_بود.mp3",
    "بفرمایید، یکم دیگه بردارید": "/audio/vocabulary/kitchen/بفرمایید،_یکم_دیگه_بردارید.mp3",
    "واقعاً سیر شدم، ممنون!": "/audio/vocabulary/kitchen/واقعاً_سیر_شدم،_ممنون!.mp3",
    "ghaza food": "/audio/vocabulary/kitchen/ghaza_food.mp3",
    "dastur pokht recipe": "/audio/vocabulary/kitchen/dastur_pokht_recipe.mp3",
    "khatereh memory": "/audio/vocabulary/kitchen/khatereh_memory.mp3",
    "eshgh love": "/audio/vocabulary/kitchen/eshgh_love.mp3",
    "سلام دوستان! من غذا درست کردم": "/audio/vocabulary/kitchen/سلام_دوستان!_من_غذا_درست_کردم.mp3",
    "چه غذایی؟": "/audio/vocabulary/kitchen/چه_غذایی؟.mp3",
    "این آش رشته است، با عشق درست کردم": "/audio/vocabulary/kitchen/این_آش_رشته_است،_با_عشق_درست_کردم.mp3",
    "وای، چقدر خوشمزه به نظر میاد!": "/audio/vocabulary/kitchen/وای،_چقدر_خوشمزه_به_نظر_میاد!.mp3"
  },
  "nature": {
    "sun": "/audio/vocabulary/nature/sun.mp3",
    "moon": "/audio/vocabulary/nature/moon.mp3",
    "star": "/audio/vocabulary/nature/star.mp3",
    "sky": "/audio/vocabulary/nature/sky.mp3",
    "earth": "/audio/vocabulary/nature/earth.mp3",
    "sea": "/audio/vocabulary/nature/sea.mp3",
    "mountain": "/audio/vocabulary/nature/mountain.mp3",
    "forest": "/audio/vocabulary/nature/forest.mp3",
    "desert": "/audio/vocabulary/nature/desert.mp3",
    "rain": "/audio/vocabulary/nature/rain.mp3",
    "snow": "/audio/vocabulary/nature/snow.mp3",
    "wind": "/audio/vocabulary/nature/wind.mp3",
    "cloud": "/audio/vocabulary/nature/cloud.mp3",
    "storm": "/audio/vocabulary/nature/storm.mp3",
    "fog": "/audio/vocabulary/nature/fog.mp3",
    "hail": "/audio/vocabulary/nature/hail.mp3",
    "thunder": "/audio/vocabulary/nature/thunder-and-lightning.mp3",
    "hot": "/audio/vocabulary/nature/hot.mp3",
    "cold": "/audio/vocabulary/nature/cold.mp3",
    "cool": "/audio/vocabulary/nature/cool.mp3",
    "humid": "/audio/vocabulary/nature/humid.mp3",
    "dry": "/audio/vocabulary/nature/dry.mp3",
    "sunny": "/audio/vocabulary/nature/sunny.mp3",
    "rainy": "/audio/vocabulary/nature/rainy.mp3",
    "snowy": "/audio/vocabulary/nature/snowy.mp3"
  },
  "food": {
    "bread": "/audio/vocabulary/food/bread.mp3",
    "rice": "/audio/vocabulary/food/rice.mp3",
    "kebab": "/audio/vocabulary/food/kebab.mp3",
    "tea": "/audio/vocabulary/food/tea.mp3",
    "water": "/audio/vocabulary/food/water.mp3",
    "milk": "/audio/vocabulary/food/milk.mp3",
    "meat": "/audio/vocabulary/food/meat.mp3",
    "vegetable": "/audio/vocabulary/food/vegetable.mp3",
    "fruit": "/audio/vocabulary/food/fruit.mp3",
    "sweet": "/audio/vocabulary/food/sweet.mp3",
    "soup": "/audio/vocabulary/food/soup.mp3",
    "salad": "/audio/vocabulary/food/salad.mp3",
    "pizza": "/audio/vocabulary/food/pizza.mp3",
    "hamburger": "/audio/vocabulary/food/hamburger.mp3",
    "sandwich": "/audio/vocabulary/food/sandwich.mp3",
    "ice cream": "/audio/vocabulary/food/ice-cream.mp3",
    "apple": "/audio/vocabulary/food/apple.mp3",
    "banana": "/audio/vocabulary/food/banana.mp3",
    "beef": "/audio/vocabulary/food/beef.mp3",
    "butter": "/audio/vocabulary/food/butter.mp3",
    "cake": "/audio/vocabulary/food/cake.mp3",
    "carrot": "/audio/vocabulary/food/carrot.mp3",
    "cheese": "/audio/vocabulary/food/cheese.mp3",
    "chicken": "/audio/vocabulary/food/chicken.mp3",
    "chocolate": "/audio/vocabulary/food/chocolate.mp3",
    "coffee": "/audio/vocabulary/food/coffee.mp3",
    "cookie": "/audio/vocabulary/food/cookie.mp3",
    "cucumber": "/audio/vocabulary/food/cucumber.mp3",
    "egg": "/audio/vocabulary/food/egg.mp3",
    "fish": "/audio/vocabulary/food/fish.mp3",
    "grape": "/audio/vocabulary/food/grape.mp3",
    "juice": "/audio/vocabulary/food/juice.mp3",
    "lamb": "/audio/vocabulary/food/lamb.mp3",
    "oil": "/audio/vocabulary/food/oil.mp3",
    "onion": "/audio/vocabulary/food/onion.mp3",
    "orange": "/audio/vocabulary/food/orange.mp3",
    "potato": "/audio/vocabulary/food/potato.mp3",
    "salt": "/audio/vocabulary/food/salt.mp3",
    "sugar": "/audio/vocabulary/food/sugar.mp3",
    "tomato": "/audio/vocabulary/food/tomato.mp3",
    "sugar water": "/audio/vocabulary/food/sugar-water.mp3"
  },
  "feelings": {
    "happy": "/audio/vocabulary/emotions/happy.mp3",
    "sad": "/audio/vocabulary/emotions/sad.mp3",
    "angry": "/audio/vocabulary/emotions/angry.mp3",
    "tired": "/audio/vocabulary/emotions/tired.mp3",
    "excited": "/audio/vocabulary/emotions/excited.mp3",
    "anxious": "/audio/vocabulary/emotions/anxious.mp3",
    "bored": "/audio/vocabulary/emotions/bored.mp3",
    "calm": "/audio/vocabulary/emotions/calm.mp3",
    "confident": "/audio/vocabulary/emotions/confident.mp3",
    "confused": "/audio/vocabulary/emotions/confused.mp3",
    "depressed": "/audio/vocabulary/emotions/depressed.mp3",
    "doubtful": "/audio/vocabulary/emotions/doubtful.mp3",
    "eager": "/audio/vocabulary/emotions/eager.mp3",
    "embarrassed": "/audio/vocabulary/emotions/embarrassed.mp3",
    "furious": "/audio/vocabulary/emotions/furious.mp3",
    "grateful": "/audio/vocabulary/emotions/grateful.mp3",
    "grief-stricken": "/audio/vocabulary/emotions/griefstricken.mp3",
    "hopeful": "/audio/vocabulary/emotions/hopeful.mp3",
    "hopeless": "/audio/vocabulary/emotions/hopeless.mp3",
    "in love": "/audio/vocabulary/emotions/in_love.mp3",
    "joyful": "/audio/vocabulary/emotions/joyful.mp3",
    "lonely": "/audio/vocabulary/emotions/lonely.mp3",
    "scared": "/audio/vocabulary/emotions/scared.mp3",
    "surprised": "/audio/vocabulary/emotions/surprised.mp3",
    "worried": "/audio/vocabulary/emotions/worried.mp3",
    "happiness": "/audio/vocabulary/emotions/happiness.mp3",
    "patience": "/audio/vocabulary/emotions/patience.mp3",
    "evocative": "/audio/vocabulary/emotions/evocative.mp3"
  },
  "travel": {
    "airplane": "/audio/vocabulary/travel/airplane.mp3",
    "airport": "/audio/vocabulary/travel/airport.mp3",
    "backpack": "/audio/vocabulary/travel/backpack.mp3",
    "bicycle": "/audio/vocabulary/travel/bicycle.mp3",
    "bus": "/audio/vocabulary/travel/bus.mp3",
    "car": "/audio/vocabulary/travel/car.mp3",
    "destination": "/audio/vocabulary/travel/destination.mp3",
    "hotel": "/audio/vocabulary/travel/hotel.mp3",
    "journey": "/audio/vocabulary/travel/journey.mp3",
    "metro": "/audio/vocabulary/travel/metro.mp3",
    "motorcycle": "/audio/vocabulary/travel/motorcycle.mp3",
    "port": "/audio/vocabulary/travel/port.mp3",
    "route": "/audio/vocabulary/travel/route.mp3",
    "ship": "/audio/vocabulary/travel/ship.mp3",
    "station": "/audio/vocabulary/travel/station.mp3",
    "suitcase": "/audio/vocabulary/travel/suitcase.mp3",
    "taxi": "/audio/vocabulary/travel/taxi.mp3",
    "ticket": "/audio/vocabulary/travel/ticket.mp3",
    "to arrive": "/audio/vocabulary/travel/to_arrive.mp3",
    "arrive": "/audio/vocabulary/travel/to_arrive.mp3",
    "to book": "/audio/vocabulary/travel/to_book.mp3",
    "book": "/audio/vocabulary/travel/to_book.mp3",
    "to depart": "/audio/vocabulary/travel/to_depart.mp3",
    "depart": "/audio/vocabulary/travel/to_depart.mp3",
    "to travel": "/audio/vocabulary/travel/to_travel.mp3",
    "tourist": "/audio/vocabulary/travel/tourist.mp3",
    "train": "/audio/vocabulary/travel/train.mp3",
    "travel": "/audio/vocabulary/travel/travel.mp3"
  },
  "city": {
    "city": "/audio/vocabulary/city/city.mp3",
    "abadan": "/audio/vocabulary/city/abadan.mp3",
    "ahvaz": "/audio/vocabulary/city/ahvaz.mp3",
    "bandar abbas": "/audio/vocabulary/city/bandar_abbas.mp3",
    "bandar mahshahr": "/audio/vocabulary/city/bandar_mahshahr.mp3",
    "bushehr": "/audio/vocabulary/city/bushehr.mp3",
    "dezful": "/audio/vocabulary/city/dezful.mp3",
    "gorgan": "/audio/vocabulary/city/gorgan.mp3",
    "ilam": "/audio/vocabulary/city/ilam.mp3",
    "isfahan": "/audio/vocabulary/city/isfahan.mp3",
    "karaj": "/audio/vocabulary/city/karaj.mp3",
    "kermanshah": "/audio/vocabulary/city/kermanshah.mp3",
    "khorramabad": "/audio/vocabulary/city/khorramabad.mp3",
    "mashhad": "/audio/vocabulary/city/mashhad.mp3",
    "qom": "/audio/vocabulary/city/qom.mp3",
    "sanandaj": "/audio/vocabulary/city/sanandaj.mp3",
    "sari": "/audio/vocabulary/city/sari.mp3",
    "shahrekord": "/audio/vocabulary/city/shahrekord.mp3",
    "shiraz": "/audio/vocabulary/city/shiraz.mp3",
    "tabriz": "/audio/vocabulary/city/tabriz.mp3",
    "tehran": "/audio/vocabulary/city/tehran.mp3",
    "urmia": "/audio/vocabulary/city/urmia.mp3",
    "yasuj": "/audio/vocabulary/city/yasuj.mp3",
    "yazd": "/audio/vocabulary/city/yazd.mp3",
    "zahedan": "/audio/vocabulary/city/zahedan.mp3"
  },
  "business": {
    "business": "/audio/vocabulary/business/business.mp3",
    "company": "/audio/vocabulary/business/company.mp3",
    "competition": "/audio/vocabulary/business/competition.mp3",
    "contract": "/audio/vocabulary/business/contract.mp3",
    "customer": "/audio/vocabulary/business/customer.mp3",
    "employee": "/audio/vocabulary/business/employee.mp3",
    "employer": "/audio/vocabulary/business/employer.mp3",
    "investment": "/audio/vocabulary/business/investment.mp3",
    "job": "/audio/vocabulary/business/job.mp3",
    "loss": "/audio/vocabulary/business/loss.mp3",
    "manager": "/audio/vocabulary/business/manager.mp3",
    "market": "/audio/vocabulary/business/market.mp3",
    "meeting": "/audio/vocabulary/business/meeting.mp3",
    "office": "/audio/vocabulary/business/office.mp3",
    "price": "/audio/vocabulary/business/price.mp3",
    "product": "/audio/vocabulary/business/product.mp3",
    "profit": "/audio/vocabulary/business/profit.mp3",
    "project": "/audio/vocabulary/business/project.mp3",
    "purchase": "/audio/vocabulary/business/purchase.mp3",
    "salary": "/audio/vocabulary/business/salary.mp3",
    "sale": "/audio/vocabulary/business/sale.mp3",
      "service": "/audio/vocabulary/business/service.mp3",
  "strategy": "/audio/vocabulary/business/strategy.mp3",
  "work": "/audio/vocabulary/business/work.mp3",
  "bank": "/audio/vocabulary/business/bank.mp3"
  },
  "clothing": {
    "t-shirt": "/audio/vocabulary/clothing/t_shirt.mp3",
    "shirt": "/audio/vocabulary/clothing/shirt.mp3",
    "pants": "/audio/vocabulary/clothing/pants.mp3",
    "jeans": "/audio/vocabulary/clothing/jeans.mp3",
    "jacket": "/audio/vocabulary/clothing/jacket.mp3",
    "shoes": "/audio/vocabulary/clothing/shoes.mp3",
    "dress": "/audio/vocabulary/clothing/dress.mp3",
    "skirt": "/audio/vocabulary/clothing/skirt.mp3",
    "socks": "/audio/vocabulary/clothing/socks.mp3",
    "hat": "/audio/vocabulary/clothing/hat.mp3",
    "shorts": "/audio/vocabulary/clothing/shorts.mp3",
    "blouse": "/audio/vocabulary/clothing/blouse.mp3",
    "underwear": "/audio/vocabulary/clothing/underwear.mp3",
    "belt": "/audio/vocabulary/clothing/belt.mp3",
    "watch": "/audio/vocabulary/clothing/watch.mp3",
    "ring": "/audio/vocabulary/clothing/ring.mp3",
    "necklace": "/audio/vocabulary/clothing/necklace.mp3",
    "earrings": "/audio/vocabulary/clothing/earrings.mp3",
    "bracelet": "/audio/vocabulary/clothing/bracelet.mp3",
    "glasses": "/audio/vocabulary/clothing/glasses.mp3",
    "bag": "/audio/vocabulary/clothing/bag.mp3",
    "handbag": "/audio/vocabulary/clothing/handbag.mp3",
    "backpack": "/audio/vocabulary/clothing/backpack.mp3",
    "coat": "/audio/vocabulary/clothing/coat.mp3"
  }
};


// Function to get audio URL for a word
export const getAudioUrl = (word: string, category: string): string | null => {
  // Handle category mapping for better compatibility
  const categoryMappings: Record<string, string> = {
    'nature': 'nature',
    'Nature': 'nature',
    'weather': 'nature', // Weather words are also in nature category
    'Weather': 'nature',
    'environment': 'nature',
    'Environment': 'nature'
  };
  
  const mappedCategory = categoryMappings[category] || category.toLowerCase();
  const categoryMap = vocabularyAudioMap[mappedCategory];
  
  if (!categoryMap) {
    console.log(`No audio map found for category: ${category} (mapped to: ${mappedCategory})`);
    return null;
  }
  
  // Try exact match first
  if (categoryMap[word.toLowerCase()]) {
    return categoryMap[word.toLowerCase()];
  }
  
  // Try partial match (for cases like "ice cream" vs "ice_cream")
  const normalizedWord = word.toLowerCase().replace(/\s+/g, '_');
  for (const [key, url] of Object.entries(categoryMap)) {
    if (key.replace(/\s+/g, '_') === normalizedWord) {
      return url;
    }
  }
  
  console.log(`No audio found for word: ${word} in category: ${mappedCategory}`);
  return null;
};

// Function to check if audio is available for a word
export const hasAudio = (word: string, category: string): boolean => {
  const audioUrl = getAudioUrl(word, category);
  return audioUrl !== null;
};

// Function to check if audio file actually exists (client-side check)
export const checkAudioFileExists = async (audioUrl: string): Promise<boolean> => {
  try {
    const response = await fetch(audioUrl, { method: 'HEAD' });
    return response.ok && response.headers.get('content-type')?.includes('audio');
  } catch (error) {
    return false;
  }
};